import { Component, Input, OnInit } from '@angular/core'

@Component({
  selector: 'ddc-example',
  templateUrl: './ddc-example.component.html',
  styleUrl: './ddc-example.component.scss',
})
export class DdcExampleComponent implements OnInit {
  @Input('text') _text: string
  constructor() {}

  ngOnInit(): void {}
}
